<template>
    <a v-if="label" class="inline-block btn btn-default margin-right"
          :class="[{'pointer-events-none cursor-auto': !filterable && !removable, 'cursor-auto no-hover': removable}, `btn-${size}`]"
          :title="filterable ? `Filter by label '${label}'` : ''"
          :href="getUrl(label)"
    >
        {{labelCharacterLimit>label.length ? label : label.substring(0,12)+".." }}
        <span class="cursor-pointer" v-if="removable" @click="removeLabel" :title="`Remove label '${label}'`">
            <strong>×</strong>
        </span>
    </a>
</template>

<script>
import urlManipulator from "src/mixins/url-manipulator.js"
export default {
    name: "IssueLabel",
    mixins: [urlManipulator],
    props: {
        label: {
            type: String,
            required: true,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: "sm",
        },
    },
    data: () => ({
        labelCharacterLimit: 12,
    }),
    methods: {
        removeLabel: function() {
            this.$emit('removelabel')
        },
        getUrl: function (label) {
            if (this.filterable) {
                return this.generateUrl('label', label)
            }
            return void(0)
        },
    },
}
</script>

<style scoped>
.issue-label-border {
    border-radius: 5px 5px 5px;
    border: 1px solid lightgray;
    padding: 5px;
}
.cursor-pointer {
    cursor: pointer;
}
.cursor-auto {
    cursor: auto;
}
.ponter-events-none {
    pointer-events: none;
}
.no-hover:hover {
    background-color: white !important;
}
</style>
